import { FC } from "react";
import "./Task.css";
import TaskProvider from "./TaskProvider";
import TaskMain from "../../component/Task/TaskMain/TaskMain";

const Task: FC = () => {
    return (
        <TaskProvider>
            <TaskMain/>
        </TaskProvider>
    );
};

export default Task;
